/* eslint-disable @typescript-eslint/no-explicit-any */
import { getTranslate } from '@/utils/api-interceptors'
import { useIsomorphicLayoutEffect } from '@/utils/useIsomorphicLayoutEffect'
import { Disclosure, Transition } from '@headlessui/react'
import { useRef, useState } from 'react'

interface InformationType {
  description: {
    vi: string
    en: string
  }
}

export const Information = ({ description }: InformationType) => {
  const targetRef = useRef<HTMLDivElement>(null) as any
  const [isReadMore, setIsReadMore] = useState(false)
  const [dimensions, setDimensions] = useState(0)

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore)
  }
  useIsomorphicLayoutEffect(() => {
    const timeout = setTimeout(() => {
      if (targetRef.current && description) {
        setDimensions(targetRef.current.clientHeight as number)
      }
    }, 400)
    return () => {
      setDimensions(0)
      setIsReadMore(false)
      if (timeout) {
        clearTimeout(timeout)
      }
      if (targetRef.current && isReadMore) {
        targetRef.current = null
      }
    }
  }, [description])

  const updatedDescription =
    description &&
    Object.fromEntries(
      Object.entries(description).map(([lang, html]) => [
        lang,
        html.replace(/pico\.vn/g, 'dienmaykho.vn'),
      ])
    )
  return (
    <>
      {description && (
        <div className='px-3 w-full pt-3 pb-4'>
          <h2 className='text-sm text-left pb-4 text-dark-900 font-bold'>
            Mô tả sản phẩm
          </h2>
          <Disclosure defaultOpen={true} as='div' className='flex w-full'>
            {({ open }) => (
              <div className='w-full relative'>
                <Transition
                  show={open}
                  enter='transition duration-1000 ease-out'
                  enterFrom='transform scale-95 opacity-0'
                  enterTo='transform scale-100 opacity-100'
                  leave='transition duration-75 ease-out'
                  leaveFrom='transform scale-100 opacity-100'
                  leaveTo='transform scale-95 opacity-0'
                >
                  <div
                    className={`flex relative flex-col items-start overflow-hidden ${
                      isReadMore ? 'max-h-full' : 'max-h-[380px]'
                    }`}
                  >
                    <div
                      className='main-description break-words leading-tight'
                      id='description-main'
                      ref={targetRef}
                      dangerouslySetInnerHTML={{
                        __html: getTranslate(updatedDescription),
                      }}
                    />
                  </div>
                </Transition>
                {!isReadMore && dimensions > 380 && (
                  <div className='h-20 bg-seeMore bg-bottom w-full absolute left-0 bottom-0'></div>
                )}
              </div>
            )}
          </Disclosure>

          {dimensions < 380 ? (
            ''
          ) : (
            <div className='flex w-full justify-center '>
              <button
                onClick={toggleReadMore}
                className={`mx-auto text-sm flex w-full justify-center items-center gap-x-1 rounded h-9 text-center font-semibold leading-9 text-primary-base`}
              >
                {!isReadMore ? 'Xem thêm' : 'Thu gọn'}
              </button>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default Information
